import angular from 'angular';
import { navbar } from './navbar/navbar.js';
import { navbarTop } from './navbarTop/navbarTop.js';
import { footer } from './footer/footer.js';
import { header } from './header/header.js';
import { homer } from './homer/homer.js';
import { forms } from './forms/forms.js';
import { utils } from './utils/utils.js';
import { configurationModule } from './configuration/configuration.js';
import { breadcrumb } from './breadcrumb/breadcrumb.js';
import { pageHeader } from './pageHeader/pageHeader.js';
import { crud } from './crud/crud.js';
import { ngDraggable } from './ngDraggable/ngDraggable.js';
import logger from './logger/logger.service.js';
import { loading } from './loading/loading.js';

const common = angular.module('common', [
    homer.name,
    navbar.name,
    navbarTop.name,
    footer.name,
    header.name,
    forms.name,
    configurationModule.name,
    utils.name,
    breadcrumb.name,
    pageHeader.name,
    crud.name,
    ngDraggable.name,
    logger.name,
    loading.name
]);

export { common };



// WEBPACK FOOTER //
// ./app/components/common/common.js